import { Model } from '@shared/models/model';
import { Expose, Type } from 'class-transformer';
import { ShipmentHistoryUpdate } from './shipment-history-update.model';
import { User } from '@features/users/models/user.model';
import { ShipmentHeadedStatus } from '@shared/enums/shipment-headed-status';
import { Fleet } from '@features/fleets/models/fleet.model';
import { Driver } from '@features/fleets/models/driver.model';
import { Truck } from '@features/fleets/models/truck.model';

export class ShipmentHistoryItem extends Model {
  @Expose()
  id: number;

  @Expose()
  action: string;

  @Expose()
  comment: null | string;

  @Expose()
  isLatestAction: boolean;

  @Expose()
  isAutomatedMobile: boolean;

  @Expose()
  isAutomatedAVL: boolean;

  @Expose()
  isLatestDriverAssigned: boolean;

  @Expose()
  avlDistance: string;

  @Expose()
  @Type(() => ShipmentHistoryUpdate)
  modifyHistory: ShipmentHistoryItem[];

  @Expose()
  modifiedCount: number;

  @Expose()
  coordinates: any;

  @Expose()
  creatorType: string;

  @Expose()
  createdAt: number;

  @Expose()
  createdBy: User;

  @Expose()
  deletedAt: number;

  @Expose()
  order?: any;

  @Expose()
  isAutomated?: boolean;

  @Expose()
  headedStatus?: ShipmentHeadedStatus;

  @Expose()
  rejectionReason?: string;

  @Expose()
  @Type(() => Fleet)
  fleet?: Fleet;

  @Expose()
  @Type(() => Driver)
  driver?: Driver;

  @Expose()
  @Type(() => Truck)
  truck?: Truck;
}
